import { Link } from 'react-router-dom';
//=============import components================
import OurPortfolioTab from 'components/common/OurPortfolioTab';
import Button from 'components/common/Button';
import PortfolioCard from 'components/common/cards/PortfolioCard';

const TabsListing = ({ list, url, cardData }) => {
  return (
    <section className='portfolioTabData'>
      <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 auto-cols-min gap-5 md:gap-0 '>
        <Link to='/portfolio/detail'>
          {cardData?.map((card) => (
            <PortfolioCard data={card} />
          ))}
        </Link>
        {list?.map((portfolioData) => (
          <OurPortfolioTab portfoilo={portfolioData} />
        ))}
      </div>
      <div className='flex justify-center'>
        {url && (
          <div className='flex justify-center mt-10 '>
            <Button url={url} title='View More' />
          </div>
        )}
      </div>
    </section>
  );
};

export default TabsListing;
